module.exports = __webpack_public_path__ + "static/media/profile_photo.f24ecba5.jpg";